import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import {
  ChangeColorEvent,
  ColorSchema,
  ThemeColor,
  SecondaryColor,
} from './interfaces/section-theme.interface';
import { secondaryColors } from './utils/secondary-colors';

@Component({
  selector: 'app-section-theme-color',
  templateUrl: './section-theme-color.component.html',
  styleUrls: ['./section-theme-color.component.css'],
})
export class SectionThemeColorComponent implements OnInit {
  @Input() showConfirmDialog = false;
  @Output() onChange = new EventEmitter<ChangeColorEvent>();
  @Output() onHideConfirmDialog = new EventEmitter<{ saved: boolean }>();

  public primaryColors: ThemeColor[] = [];
  public secondaryColors: SecondaryColor[] = secondaryColors;

  selectedPrimaryColor!: ThemeColor;
  selectedSecondaryColor!: SecondaryColor;
  colorSchema?: ColorSchema;
  showProgress: boolean = false;
  showSkeleton: boolean = true;
  defaultValues: { primary: string; secondary: string } | undefined;

  constructor(
    private notification: NotificationService,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.getThemeColors();
  }

  onSelectColor() {
    const colors = {
      primary: this.selectedPrimaryColor.hexValue,
      secondary: this.selectedSecondaryColor.hex,
    };

    this.colorSchema = colors;

    this.onChange.emit({
      defaultValues: {
        primary: this.defaultValues?.primary ?? '',
        secondary: this.defaultValues?.secondary ?? '',
      },
      primary: this.selectedPrimaryColor.name,
      secondary: this.selectedSecondaryColor.name,
    });
  }

  closeConfirmDialog(saved: boolean = false) {
    this.showProgress = false;
    this.onHideConfirmDialog.emit({ saved });
  }

  applyTheme() {
    this.showProgress = true;

    const data = {
      primaryTheme: this.selectedPrimaryColor.name,
      secondaryTheme: this.selectedSecondaryColor.name,
    };

    this.api.updateDirect('operator/operator-config', data).subscribe({
      next: () => {
        this.notification.sendNotification(
          'Cambios aplicados satisfactoriamente'
        );
        this.closeConfirmDialog(true);
        this.showProgress = false;

        this.defaultValues = {
          primary: this.selectedPrimaryColor.name,
          secondary: this.selectedSecondaryColor.name,
        };

        this.onChange.emit({
          primary: this.selectedPrimaryColor.name,
          secondary: this.selectedSecondaryColor.name,
          defaultValues: {
            primary: this.defaultValues.primary,
            secondary: this.defaultValues.secondary,
          },
        });
      },
      error: () => {
        this.notification.sendNotification(
          'Ha ocurrido un error al querer guardar los cambios'
        );
        this.showProgress = false;
      },
    });
  }

  getOperatorConfig(operatorId?: string) {
    this.showSkeleton = true;

    const url = operatorId
      ? `operator/operator-config?operatorId=${operatorId}`
      : `operator/operator-config`;

    this.api.list(url).subscribe({
      next: (res) => {
        this.showSkeleton = false;

        const data = res.data;

        if (data.themePrimary?.name) {
          const found = this.primaryColors?.find(
            (theme) => theme.name === data.themePrimary?.name
          );
          if (found) {
            this.selectedPrimaryColor = found;
          }
        }

        if (data.themeSecondary?.name) {
          const found = this.secondaryColors.find(
            (theme) => theme.name === data.themeSecondary?.name
          );
          if (found) {
            this.selectedSecondaryColor = found;
          }
        }

        this.defaultValues = {
          primary: this.selectedPrimaryColor?.name,
          secondary: this.selectedSecondaryColor?.name,
        };

        this.onSelectColor();
      },
      error: (error) => {
        this.showSkeleton = false;
        console.log('Error al obtener la configuración del operador', error);
      },
    });
  }

  getThemeColors() {
    const url = `${ApiCore.OPERATOR}/get-theme-colors`;
    this.api.get(url).subscribe({
      next: (val) => {
        this.primaryColors = val.data.filter(
          (item: ThemeColor) => item.name !== 'tema_gris'
        );
        this.getOperatorConfig();
      },
      error: (error) => {
        console.log({ error });
        console.log('ERROR getting colors');
      },
    });
  }
}
